<template>
  <div class="player-component">
    <div id="livePlayer" v-show="liveStatus!=0">
    </div>
    <div class="noStartTxt" v-if="liveStatus===0">老师正在向你奔来 稍等一下下哦</div>
    <div class="video-control">
      <template v-if="controlShow && liveStatus === 1">
        <div class="control-top">
          <img src="../../../assets/img/live/back.png" alt="" @click="back" class="control-icon" />
          <span class="live-title">{{ $route.query.liveName }}</span>
        </div>
        <div class="control-bottom">
          <div @click="playPause">
            <!-- <template v-if="videoPlaying">
              <img src="../../../assets/img/live/end.png" alt="" class="control-icon">
            </template>
            <template v-else> -->
            <img
              v-show="!videoPlaying"
              src="../../../assets/img/live/start.png"
              alt=""
              class="control-icon"
            />
            <!-- </template> -->
          </div>
          <div @click="fullScreenClick">
            <img src="../../../assets/img/live/full_screen.png" alt="" class="control-icon" />
          </div>
        </div>
      </template>
    </div>
    <Lottry />
    <Sign />
    <!-- 答题卡 -->
    <Answer />
  </div>
</template>
<script>
// eslint-disable-next-line import/extensions
import Lottry from './lottry';
// eslint-disable-next-line import/extensions
import Sign from './sign';
import { sendUploadStudyProgress } from '@/api/live';
import { mapState } from 'vuex';
import moment from 'moment';
import Answer from './answer.vue';
import { data } from 'autoprefixer';
export default {
  props: {
    initData: {
      type: Object,
      default: () => {},
    },
    buyInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {
    videoPlaying(val) {
      if (val) {
        this.isLiveStart = true;
        this.studyStartTime = moment();
        this.studyTime = 0;
        this.lastReportTime = 0;
        this.reportTime = 0;
        this.firstReport = true;
        this.sendUploadStudyProgressFun(this.liveData, 1);
      }
    },
  },
  data() {
    return {
      loadCC: true,
      liveStatus: 0, // 0未直播，1直播中，2直播结束
      fullscreenVal: false,
      controlShow: true,
      controlTimer: null,
      videoPlaying: false,
      studyStartTime: 0, // 学习开始
      studyTime: 0, // 学习时长
      reportTime: 0, // 本次上报时间
      lastReportTime: 0, // 上次上报时间
      isLiveStart: false,
      firstReport: false,
    };
  },
  components: { Lottry, Sign, Answer },
  async created() {
  },
  mounted() {
    this.liveData = this.$route.query;
    this.liveData.buyRecord = this.buyInfo.id;
    this.isLiveStart = false;
    window.clearInterval(this.uploadTimer);
    this.initLive();
  },
  methods: {
    // 初始化播放器
    async initLive() {
      // eslint-disable-next-line no-undef
      DWLive.init(this.initData);
      DWLive.onLoginSuccess = (data)=> {
        this.loginSuccess(data)
      }
      // eslint-disable-next-line no-undef
      DWLive.onLoginError = (data) => {}; // 鉴权处理
      // eslint-disable-next-line no-undef
      DWLive.onLiveStart = () => {
        console.log('开始直播');
        
      }; // 开始直播
      DWLive.onLiveStarting = () => {
         console.log('开始直播111',);
         this.$parent.checkLiveStatus(1)
        // this.isLiveStart = true
        // this.studyStartTime = moment()
        // this.studyTime = 0
        // this.lastReportTime = 0
        // this.reportTime = 0
        // this.firstReport = true
        // this.sendUploadStudyProgressFun(this.liveData, 1)
        this.liveStatus = 1;

        this.controlShow = true;
        this.videoControl();
        this.videoPlay();
        this.controlTimer = setTimeout(() => {
          this.controlShow = false;
        }, 8000);
        // console.log('直播中');
      }; // 开始直播
      // eslint-disable-next-line no-undef
      DWLive.onLiveEnd = () => {
        console.log('停止直播');
        this.stopLive();
      }; // 停止直播
    },
    loginSuccess(data){
      console.log(data,44444)
      const {liveDuration}=data.live;// liveDuration 直播持续时长，通过改字段判断是否
      if(liveDuration<=0){
        this.$parent.checkLiveStatus(0)
      }
    },
    videoControl() {
      let controlTime = () => {
        this.controlShow = true;
        const myVideo = document.getElementById('player_live');
        this.videoPlaying = !myVideo.paused;
        if (this.controlTimer) {
          clearTimeout(this.controlTimer);
        }
        this.controlTimer = setTimeout(() => {
          this.controlShow = false;
        }, 8000);
      };
      document.getElementById('player_live').controls = false;
      document.getElementsByClassName('video-control')[0].addEventListener(
        'click',
        () => {
          if (this.liveStatus === 1) {
            controlTime();
          }
        },
        false,
      );
      this.$nextTick(() => {
        // 刷新播放状态
        const myVideo = document.getElementById('player_live');
        this.videoPlaying = !myVideo.paused;
        // 监听全屏
        myVideo.addEventListener('webkitendfullscreen', () => {
          this.videoPlaying = !myVideo.paused;
        });
      });
    },

    // 播放，暂停
    playPause() {
      const myVideo = document.getElementById('player_live');
      if (myVideo.paused) {
        myVideo.play();
        this.videoPlaying = true;
      }
      // else {
      //   myVideo.pause();
      //   this.videoPlaying = false;
      // }
    },

    videoPlay() {
      setTimeout(() => {
        const myVideo = document.getElementById('player_live');
        myVideo.play().then(() => {
          this.videoPlaying = true;
        });
      }, 1000);
    },

    fullScreenClick() {
      if (this.fullscreenVal) {
        this.fullscreenVal = false;
        DWLive.switchFullScreen(false);
        this.$nextTick(() => {
          const myVideo = document.getElementById('player_live');
          this.videoPlaying = !myVideo.paused;
        });

        /*const de = document;
        if (de.exitFullscreen) {
          de.exitFullscreen();
        } else if (de.mozCancelFullScreen) {
          de.mozCancelFullScreen();
        } else if (de.webkitCancelFullScreen) {
          de.webkitCancelFullScreen();
        }*/
      } else {
        this.fullscreenVal = true;
        DWLive.switchFullScreen(true);
        this.$nextTick(() => {
          const myVideo = document.getElementById('player_live');
          this.videoPlaying = !myVideo.paused;
        });
        /*const de = document.getElementById("player_live");
        de.webkitEnterFullScreen()*/
        /*if (de.requestFullscreen) {
          de.requestFullscreen();
        } else if (de.mozRequestFullScreen) {
          de.mozRequestFullScreen();
        } else if (de.webkitRequestFullScreen) {
          de.webkitRequestFullScreen();
        }
        screen.orientation.lock("landscape");*/
      }
    },

    back() {
      if (this.fullscreenVal) {
        this.fullScreenClick();
      } else {
        this.$router.back();
      }
    },

    // 上传学习进度
    async sendUploadStudyProgressFun(liveData, isDrag) {
      if (!this.firstReport && isDrag === 1) {
        return;
      }
      window.clearInterval(this.uploadTimer);
      this.lastReportTime = moment();
      if (isDrag !== 3) {
        // isDrag === 3 上报结束的情况下不重启定时器
        this.uploadTimer = setInterval(() => {
          const nowTime = moment();
          this.reportTime = nowTime.diff(this.lastReportTime, 'seconds');
          this.studyTime = nowTime.diff(this.studyStartTime, 'seconds');
          this.sendUploadStudyProgressFun(liveData, 0);
        }, 300000);
      }

      let { chapterId, liveId, buyRecord, courseId } = liveData;
      let { id } = this.userInfo;
      let data = {
        userId: id,
        productId: courseId,
        productSkuId: this.buyInfo.skuId,
        userProductId: this.buyInfo.id,
        curriculumId: this.buyInfo.productCurriculumId,
        chapterId,
        chapterName: this.$route.query.liveName,
        sourceType: 2,
        position: 0,
        reportTime: this.reportTime,
        learnProgress:0,
        isDrag,
        source: 5,
        ua: window.navigator.userAgent,
        updateTime: this.$root.getLocalTime(),

      };
      const res = await sendUploadStudyProgress(data);
      if (res.code === 0) {
        // console.log("学习进度保存成功");
        this.firstReport = false;
      } else {
        window.clearInterval(this.uploadTimer);
      }
    },

    stopLive(val) {
      if (val === 'stop') {
        DWLive.destroy();
      }
      if (!this.isLiveStart) {
        return;
      }
      if (this.lastReportTime === 0 || this.studyStartTime === 0) {
        return;
      }
      window.clearInterval(this.uploadTimer);
      this.liveStatus = 2;
      const nowTime = moment();
      this.reportTime = nowTime.diff(this.lastReportTime, 'seconds');
      this.studyTime = nowTime.diff(this.studyStartTime, 'seconds');
      this.sendUploadStudyProgressFun(this.liveData, 3);
      this.isLiveStart = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.player-component {
  position: relative;
  height: 100%;
  max-height: calc(100vw * 0.5625);
  #livePlayer {
    width: 100%;
    height: 100%;
  }
  .noStartTxt{
    display: flex;
    align-items: center;
    justify-content: center;
     width: 100%;
    height: 100%;
    color: #fff;
    font-size: 18px;
    text-align: center;
  }
  .video-control {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    color: white;

    .control-top {
      display: flex;
      align-items: center;

      .live-title {
        width: 250px;
        overflow: hidden;
        color: white;
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .control-icon {
        margin-right: 0;
      }
    }

    .control-bottom {
      display: flex;
      justify-content: space-between;
      height: 60px;
      padding-left: 10px;
    }
  }

  .control-icon {
    width: 30px;
    height: 30px;
    margin: 15px;
  }

  #player_live {
    width: 100%;
    max-height: calc(100vw * 0.5625);
  }
}
.fullscreen {
  #player_live {
    width: 100%;
    max-height: 100vh;
  }
}
</style>
